import { HTTP } from "@/utils/http-common"

export default {
  getTeam($, projectId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`event/${projectId}/team`)
        .then(response => resolve(response.data))
        .catch(err => {
          return reject(err)
        })
    })
  },
  updateMemberRole($, projectId, id, role) {
    return new Promise((resolve, reject) => {
      HTTP.post(`event/${projectId}/team`, {
        id: id,
        role: role ? role : null
      })
        .then(r => {
          if (r.data.error)
            $.$store.commit("app/message", {
              msg: r.data.error,
              color: "error"
            })

          resolve(r)
        })
        .catch(err => {
          $.$store.commit("app/message", {
            msg: err.response?.data?.error
              ? err.response?.data?.error
              : "Something went wrong, please try again later",
            color: "error"
          })
          reject(err)
        })
    })
  },
  getInspectors($, projectId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`event/${projectId}/inspectors`)
        .then(r => {
          resolve(r)
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  sendInvitationMeeting($, invitee) {
    return new Promise((resolve, reject) => {
      HTTP.post(`account/invitation/meeting`, invitee)
        .then(r => {
          resolve(r)
        })
        .catch(err => {
          $.$store.commit("app/message", {
            msg: err.response?.data?.error
              ? err.response?.data?.error
              : "Something went wrong, please try again later",
            color: "error"
          })
          reject(err)
        })
    })
  },
  sendSmsInvitationMeeting($, invitee) {
    return new Promise((resolve, reject) => {
      HTTP.post(`account/invitation/sms-meeting`, invitee)
        .then(r => {
          resolve(r)
        })
        .catch(err => {
          $.$store.commit("app/message", {
            msg: err.response?.data?.error
              ? err.response?.data?.error
              : "Something went wrong, please try again later",
            color: "error"
          })
          reject(err)
        })
    })
  },
  sendInvite($, projectId, invites) {
    return new Promise((resolve, reject) => {
      HTTP.post(`event/${projectId}/team/invitations`, invites)
        .then(function (response) {
          if (!response.data.invalid || response.data.invalid.length === 0) {
            $.$store.commit("app/message", {
              msg: "invite(s) sent",
              color: "success"
            })
            $.invites = [
              {
                email: "",
                errors: "",
                privileges: {
                  inspector: false,
                  operator: true
                }
              }
            ]
          } else {
            let err = response.data
            let item, email, index
            for (item in err.invalid) {
              for (let prop in err.invalid[item]) {
                email = prop
                break
              }
              index = invites.findIndex(x => x.email == email)
              $.invites[index].errors = err.invalid[item][email]
            }
            $.$store.commit("app/message", {
              msg: "some invites failed or are already pending",
              color: "warning"
            })
          }
          return resolve(response)
        })
        .catch(function (error) {
          let err = error.response.data
          if (err !== undefined) {
            let item, email, index
            if (err.error) {
              $.$store.commit("app/message", {
                msg: err.error,
                color: "error"
              })
            } else if (err.invalid) {
              for (item in err.invalid) {
                for (let prop in err.invalid[item]) {
                  email = prop
                  break
                }
                index = invites.findIndex(x => x.email == email)
                $.invites[index].errors = err.invalid[item][email]
              }
              $.$store.commit("app/message", {
                msg: "An email has already been sent to this user",
                color: "error"
              })
            } else {
              $.$store.commit("app/message", {
                msg: err.detail,
                color: "error"
              })
            }
          } else {
            $.$store.commit("app/message", {
              msg: err,
              color: "error"
            })
          }
          return reject(error)
        })
    })
  },
  selfRemove($, projectId, userId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/event/${projectId}/team/member/${userId}`).then(r => {
        resolve(r.data)
      })
    })
  }
}
